export const navigateCallbackMap = new Map<string, () => void>();
